/**
 * Click-to-chat links (wa.me). No Meta Business account, no API, no approval —
 * the link simply opens WhatsApp with the conversation and an optional draft.
 */
const DEFAULT_NUMBER = '4917662655180';

/** wa.me accepts digits only: country code first, no '+', no spaces. */
export const normalizeNumber = (value: string | undefined): string =>
  (value ?? '').replace(/\D/g, '') || DEFAULT_NUMBER;

export function whatsappLink(number: string | undefined, message?: string): string {
  const query = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${normalizeNumber(number)}${query}`;
}

/** Pretty-prints a raw wa.me number back into a readable phone number. */
export function formatWhatsappNumber(value: string | undefined): string {
  const digits = normalizeNumber(value);
  return digits.startsWith('49')
    ? `+49 ${digits.slice(2, 5)} ${digits.slice(5)}`.trim()
    : `+${digits}`;
}
